import React from 'react';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// import ReservationForm from './ReservationForm'; // Ваш компонент с формой process.env.REACT_APP_RECAPTCHA_SITE_KEY
import Reservation from '../Reservation';

function ReservationCaptchWrapp() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={"6LebiaAqAAAAANi72BcWiiC8iT1sqOnZP9eKwPt_"}>
        <Reservation />
    </GoogleReCaptchaProvider>
  );
}

export default ReservationCaptchWrapp;